import { render, staticRenderFns } from "./JgpNum.vue?vue&type=template&id=510fd82e&"
import script from "./JgpNum.vue?vue&type=script&lang=js&"
export * from "./JgpNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports